/* eslint-disable */
import React from "react";

/**
 * Footer component that displays a copyright notice.
 *
 * @component
 * @returns {JSX.Element} A footer section with a copyright message.
 */
const Footer = () => (
	<div className="mt-24">
		<p className="dark:text-gray-200 text-gray-700 text-center m-20">
			© 2025 All rights reserved by WorksideSoftware.com
		</p>
	</div>
);

export default Footer;
